export function authHeader() {
    const token = JSON.parse(localStorage.getItem('e_3235'));
    if ( token ) {
        return { 'Authorization' : 'Bearer ' + token }
    } else {
        return {}
    }
}



// WEBPACK FOOTER //
// ./src/helpers/authHeader.js